"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceEventService = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var Browser_service_1 = require("../Browser.service");
var Cache_service_1 = require("../../../core/services/storage/Cache.service");
/**
 * @description - ReferenceEventService class for keeping track of reference event:
 * https://seismic.atlassian.net/wiki/spaces/FEC/pages/2701787149/Tracking+User+Actions+Before+Content+View+Draft
 * Track last user interaction before a content view.
 * Use localStorage to allow for tracking content,
 * even when opening content in a new window or tab.
 */
var ReferenceEventService = /** @class */ (function () {
    function ReferenceEventService(cacheService, browserService) {
        var _this = this;
        this.cacheService = cacheService;
        this.browserService = browserService;
        this.isReferenceEventRead = false;
        /**
         * Call this upon initialization of the app to add window navigation listeners
         * to clear local storage cache on back/forward navigation.
         * This allows reference events to be used by further user interactions
         * in addition to content view such as content view download until user navigates away.
         */
        this.addRouteEvents = function () {
            _this.removeRouteEvents();
            // clear the reference event if use clicks back button
            window.addEventListener('popstate', _this.clearReferenceEvent, false);
            // clear the reference event if hash # url changes
            window.addEventListener('hashchange', _this.clearReferenceEvent, false);
        };
        this.removeRouteEvents = function () {
            window.removeEventListener('popstate', _this.clearReferenceEvent, false);
            window.removeEventListener('hashchange', _this.clearReferenceEvent, false);
        };
        /**
         * setReferenceEvent - pass trackEvent function, content ID, and optional properties, adds to localstorage
         * Use this method to track Reference events.
         * https://seismic.atlassian.net/wiki/spaces/FEC/pages/2701787149/Tracking+User+Actions+Before+Content+View+Draft
         * @param trackEvent - trackEvent method from react-tracking tracking object
         * @param contentId - content ID used to validate against in the getReferenceEvent method
         * @param trackEventObj - optional properties to pass to trackEvent
         */
        this.setReferenceEvent = function (trackEvent, contentId, trackEventObj) {
            if (trackEvent === void 0) { trackEvent = function (eventObj) {
                console.info('Please pass a tracking function for your event:', eventObj);
            }; }
            if (trackEventObj === void 0) { trackEventObj = {}; }
            trackEvent(__assign(__assign({}, trackEventObj), { id: contentId }));
            _this.isReferenceEventRead = false;
            var dataLayer = window.dataLayer;
            var lastDataLayerItem = (dataLayer === null || dataLayer === void 0 ? void 0 : dataLayer.length) ? dataLayer.pop() : undefined;
            _this.cacheService.set('dataLayer', lastDataLayerItem, 'local', 60);
        };
        /**
         * getReferenceEvent - gets reference event from localstorage
         * Use this method to get Reference events, e.g. use in ContentViewV2 and ContentDownloadV2 to add reference object
         * https://seismic.atlassian.net/wiki/spaces/FEC/pages/2701787149/Tracking+User+Actions+Before+Content+View+Draft
         * @param contentId - content ID used to validate against the id from the trackReferenceEvent method
         * @returns reference class object
         */
        this.getReferenceEvent = function (contentId) {
            var _a;
            var referenceObj;
            var dataLayerItem = (_a = _this.cacheService.get('dataLayer')) === null || _a === void 0 ? void 0 : _a.value;
            if ((dataLayerItem === null || dataLayerItem === void 0 ? void 0 : dataLayerItem.id) === contentId && !_this.browserService.isPageAccessedByReload()) {
                referenceObj = dataLayerItem;
            }
            _this.isReferenceEventRead = true;
            return referenceObj;
        };
        /**
         * clearReferenceEvent - clears reference event from localstorage
         */
        this.clearReferenceEvent = function () {
            if (_this.isReferenceEventRead) {
                _this.cacheService.removeItem('dataLayer');
            }
        };
    }
    ReferenceEventService = __decorate([
        CommonService_decorator_1.CommonService('ReferenceEventService'),
        __metadata("design:paramtypes", [Cache_service_1.CacheService, Browser_service_1.BrowserService])
    ], ReferenceEventService);
    return ReferenceEventService;
}());
exports.ReferenceEventService = ReferenceEventService;
//# sourceMappingURL=ReferenceEvent.service.js.map